// Utilidad compartida entre `nativeScanner.ts` y `wasmScanner.ts`: abrir la
// cámara trasera y cortarla. No importa ningún decodificador (nativo ni
// WASM), así que vivir fuera de ambos adaptadores no rompe el aislamiento de
// ADR-012 — la prueba de aislamiento solo vigila `zxing-wasm`/`@zxing`.
export async function openEnvironmentCamera(
  video: HTMLVideoElement,
): Promise<MediaStream> {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: { facingMode: "environment" },
  });
  video.srcObject = stream;
  await video.play();
  return stream;
}

export function stopCameraStream(stream: MediaStream | null): void {
  if (!stream) return;
  for (const track of stream.getTracks()) track.stop();
}
